import React from "react";
import {Form, Button} from "react-bootstrap";
import Compress from "browser-image-compression";
import Loading from "./Loading.gif";

class EditProfileForm extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {
        data:{
            name: props.name
        },
        gravatarImageURL: props.gravatarImageURL,
        fileUrl: "",
        imageUploading: false,
        failed: false,
        fs: "No File Choosen"
      };
    }
    onchange = event => this.setState({
        data: {...this.state.data, [event.target.name] : event.target.value }
    });
    filechange = e => {
        this.setState({imageUploading: true, failed: false})
        var files = e.target.files[0];
        const options = {
            maxSizeKB: 100,
            useWebWorker: true
        };
        Compress(files, options).then(compressBlob => {
            this.setState({imageUploading: false, data:{...this.state.data, file:compressBlob}})
        }).catch(err => {
            this.setState({fileUrl: "",failed: true, imageUploading: false})
        })
    }
    filechangee = e => {
        this.setState({imageUploading: true, failed: false})
        var files = e.target.files[0];
        const options = {
            maxSizeKB: 100,
            useWebWorker: true
        };
        Compress(files, options).then(compressBlob => {
            this.setState({fileUrl: URL.createObjectURL(compressBlob), imageUploading: false, fs: files.name,data:{...this.state.data, file:compressBlob}})
        }).catch(err => {
            this.setState({fs: "No File Choosen", fileUrl: "",failed: true, imageUploading: false})
        })
    }
    setURL = e => {
        var {file} = this.state.data;
        this.setState({fileUrl: URL.createObjectURL(file)});
    }
    onsubmit = (e) => {
        e.preventDefault();
    };
    uploadImage = () => {
        var formData = new FormData();
        formData.append('imageToUpload', this.state.data.file, this.state.data.file.name)
        this.setState({loading: true});
        this.props.uploadImage(formData);
    };
    changeName = () => {
        this.props.changeName(this.state.data.name);
    };
    render(){
        const {name, file} = this.state.data;
        const {gravatarImageURL, imageUploading, failed, fileUrl} = this.state;
        const {onchange, filechange,filechangee, onsubmit, setURL} = this;
        return(
            <div className="form_comn editProfileForm">
                <Form onSubmit={onsubmit}>
                    <Form.Group>
                        <Form.Label>Name:</Form.Label>
                        <Form.Control 
                            type="text"
                            name="name"
                            value={name}
                            onChange={onchange}
                            placeholder="Your Name"
                            autoComplete="off"
                        />
                    </Form.Group>
                    {(this.props.name!==name)&&(<div><Button variant="success" onClick={this.changeName}>Change Name</Button><br/></div>)}
                    <Form.Group className="gravatarComponent">
                        <Form.Label>{!gravatarImageURL ? "No Image Uploaded:" :"Change Image:"} </Form.Label>

                        {(gravatarImageURL !== "Default.svg") ? (
                            <div className="gravatarComponent2">
                        <img 
                            src={"/root/Images/"+gravatarImageURL}
                            className="editGravatar" 
                            alt="gravatar" 
                        />{imageUploading && (
                        <img 
                            src={Loading}
                            className="loading" 
                            alt="gravatar" 
                        />)}
                        {failed && (
                            <h1 className="failed">Failed</h1>
                        )}
                        <input 
                            type="file"
                            onChange={filechange}
                            accept=".png, .jpg, .bmp"
                            hidden
                            id="actual_btn"
                        /><label htmlFor="actual_btn" className="btn-file">Choose File</label>
                        {file && !failed&&!imageUploading&&(<div className="preview_btn" onClick={setURL}>Preview</div>)}
                        {fileUrl && (<img src={fileUrl} alt="fileURL" className="preview"/>)}</div>):(<div className="gravatarComponent2">
                        {!imageUploading ? 
                            fileUrl && (
                        <img 
                            src={this.state.fileUrl}
                            className="editGravatar" 
                            alt="gravatar" 
                        />)
                        :<img 
                            src={Loading}
                            className="editGravatar" 
                            alt="gravatar" 
                        />}
                        {failed && (
                            <h1 className="failed2">Failed</h1>
                        )}
                        <input 
                            type="file"
                            onChange={filechangee} 
                            accept=".png, .jpg, .bmp"
                            id="actual_btn"
                            hidden
                        /><label htmlFor="actual_btn" className="btn-fileee mt-2">Choose File</label><span className={this.state.fs!=="No File Choosen" ? "fss": "fs"}>{this.state.fs}</span></div>)}
                    </Form.Group><br/>
                    {this.state.data.file && !this.state.failed && (
                    <Button variant="success" className="change_img ub" onClick={this.uploadImage}>Change Image</Button>)}
                </Form>
            </div>
        );
    };
};

export default EditProfileForm;